var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useEffect } from "react";
import { postOrder } from "../../../../../data/api";
import { setCartData } from "../../../../../store/Cart/actions";
import { clearInlineErrors, setFormIsSubmitting, setInlineError } from "../../../../../store/AppState/actions";
import { useDispatch, useSelector } from "react-redux";
import { handleErrors, handleSubmittedOrder } from "../../../../../data/helpers";
import useWidgetHistory from "../../../../../hooks/useWidgetHistory";
import Constants from "../../../../../data/constants";
import { WidgetContext } from "../../../../Widget";
import { isEqual } from "lodash";
import { AppFormContext } from "../../../../../App";
import { useStripe } from "@stripe/react-stripe-js";
import useWidgetAnalytics from "../../../../../hooks/useWidgetAnalytics";
import PaymentForm from "../../../../PaymentProcessors/PaymentForm";
import { phone } from "phone";
import { clearSubmittedForms } from "../../../../../store/Record/actions";
import CartExpiredModal from "./CartExpiredModal";
import { integrationsEventOrderPlaced } from "../../../../../store/Integrations/actions";
import { useSpecificBFPayment } from "../../../../../hooks/useSpecificBFPayment";
var getCountryCodeSafe = function (sourceCountry) {
    if (sourceCountry) {
        if (sourceCountry.length === 2) {
            return sourceCountry;
        }
        else if (sourceCountry.toLowerCase() === "united states") {
            return "US";
        }
    }
    return undefined;
};
var useTypedSelector = useSelector;
var CartCheckout = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var cart = _a.cart, currency = _a.currency, eventData = _a.eventData, path = _a.path, isCheckout = _a.isCheckout, isMobile = _a.isMobile;
    var _q = __read(React.useState(), 2), initialValues = _q[0], setInitialValues = _q[1];
    var _r = __read(React.useState(), 2), paymentType = _r[0], setPaymentType = _r[1];
    var _s = __read(React.useState(), 2), iframeSrc = _s[0], setIframeSrc = _s[1];
    var _t = __read(React.useState(false), 2), showIframeSrc = _t[0], setShowIframeSrc = _t[1];
    var _u = __read(React.useState(), 2), boltToken = _u[0], setBoltToken = _u[1];
    var _v = __read(React.useState(false), 2), showPrefilledMessage = _v[0], setShowPrefilledMessage = _v[1];
    var _w = __read(React.useState(false), 2), isCartExpired = _w[0], setIsCartExpired = _w[1];
    var attendeeTypeData = useTypedSelector(function (store) { return store.attendees.attendeeTypeData; });
    var isAutoRegMode = useTypedSelector(function (store) { return store.app; }).isAutoRegMode;
    var dispatch = useDispatch();
    var history = useWidgetHistory();
    var stripe = useStripe();
    var analytics = useWidgetAnalytics();
    var removeSpecificBFPayment = useSpecificBFPayment().removeSpecificBFPayment;
    var externalAccount = useContext(WidgetContext).externalAccount;
    var formikContext = useContext(AppFormContext).formikContext;
    var paymentGroups = [];
    (_b = cart === null || cart === void 0 ? void 0 : cart.paymentMethods) === null || _b === void 0 ? void 0 : _b.forEach(function (p) {
        if (p.infoGrouping !== "None" && p.infoGrouping !== "CheckPO") {
            if (!paymentGroups.includes(p.infoGrouping)) {
                paymentGroups.push(p.infoGrouping);
            }
        }
        else {
            if (!paymentGroups.includes(p.name)) {
                paymentGroups.push(p.name);
            }
        }
    });
    var setCheckoutError = function (errorMessage) {
        dispatch(setInlineError({ checkoutForm: errorMessage }));
    };
    var getPrefilledValues = function (setShowPrefilled) {
        var _a, _b, _c, _d;
        if (setShowPrefilled === void 0) { setShowPrefilled = true; }
        if (externalAccount) {
            if (setShowPrefilled) {
                setShowPrefilledMessage(true);
            }
            if (externalAccount.phone) {
                var res = phone(externalAccount.phone, { validateMobilePrefix: false });
                if (res.isValid) {
                    externalAccount.phone = res.phoneNumber;
                }
            }
            return __assign(__assign({}, externalAccount), { shippingId: (_a = cart === null || cart === void 0 ? void 0 : cart.shippingId) !== null && _a !== void 0 ? _a : undefined, country: getCountryCodeSafe(externalAccount.country) || getCountryCodeSafe(eventData === null || eventData === void 0 ? void 0 : eventData.clientCountry) || "US", password: "", confirmPassword: "" });
        }
        else if (cart === null || cart === void 0 ? void 0 : cart.checkoutInfo) {
            if (setShowPrefilled) {
                setShowPrefilledMessage(true);
            }
            if (cart.checkoutInfo.phone) {
                var res = phone(cart.checkoutInfo.phone, { validateMobilePrefix: false });
                if (res.isValid) {
                    cart.checkoutInfo.phone = res.phoneNumber;
                }
            }
            return __assign(__assign({}, cart === null || cart === void 0 ? void 0 : cart.checkoutInfo), { shippingId: (_b = cart === null || cart === void 0 ? void 0 : cart.shippingId) !== null && _b !== void 0 ? _b : undefined, country: getCountryCodeSafe(cart.checkoutInfo.country) ||
                    getCountryCodeSafe(eventData === null || eventData === void 0 ? void 0 : eventData.clientCountry) ||
                    "US", password: "", confirmPassword: "" });
        }
        return {
            shippingId: (_c = cart === null || cart === void 0 ? void 0 : cart.shippingId) !== null && _c !== void 0 ? _c : undefined,
            country: (_d = getCountryCodeSafe(eventData === null || eventData === void 0 ? void 0 : eventData.clientCountry)) !== null && _d !== void 0 ? _d : "US",
            password: "",
            confirmPassword: "",
        };
    };
    useEffect(function () {
        if (path === Constants.Routes.checkout && eventData && cart && attendeeTypeData) {
            analytics.startCheckout(eventData, cart);
            if (!(cart === null || cart === void 0 ? void 0 : cart.attendees)) {
                history.push((isAutoRegMode
                    ? Constants.Routes.autoreg
                    : (eventData === null || eventData === void 0 ? void 0 : eventData.verbiage) === "Tickets"
                        ? Constants.Routes.tickets
                        : Constants.Routes.register)
                    .replace(":clientKey", eventData.clientKey)
                    .replace(":urlKey", eventData.urlKey)
                    .replace(":eventNumber", eventData.eventNumber.toString()));
            }
            else {
                var vals = getPrefilledValues();
                setInitialValues(vals);
            }
        }
    }, [path, attendeeTypeData]);
    useEffect(function () {
        var _a, _b;
        if ((cart === null || cart === void 0 ? void 0 : cart.paymentMethods) && !paymentType) {
            setPaymentType(!!((_a = cart === null || cart === void 0 ? void 0 : cart.paymentMethods) === null || _a === void 0 ? void 0 : _a.find(function (p) { return p.infoGrouping === "Card"; })) ? "Card" : (_b = cart === null || cart === void 0 ? void 0 : cart.paymentMethods[0]) === null || _b === void 0 ? void 0 : _b.name);
        }
    }, [cart === null || cart === void 0 ? void 0 : cart.paymentMethods]);
    useEffect(function () {
        var _a, _b;
        if (path === Constants.Routes.cart && !isEqual(getPrefilledValues(false), initialValues)) {
            if (formikContext && ((_b = (_a = formikContext.status) === null || _a === void 0 ? void 0 : _a.bag) === null || _b === void 0 ? void 0 : _b.isCheckout)) {
                var newValues = getPrefilledValues();
                setInitialValues(newValues);
                formikContext.resetForm({ values: newValues });
            }
        }
    }, [externalAccount, cart === null || cart === void 0 ? void 0 : cart.checkoutInfo, path, (_c = formikContext === null || formikContext === void 0 ? void 0 : formikContext.status) === null || _c === void 0 ? void 0 : _c.bag]);
    var placeOrder = function (values, payload, formikBag, setGlobalError, handleAction) {
        if (handleAction === void 0) { handleAction = true; }
        if (cart && eventData) {
            var payloadToPost = __assign(__assign({}, payload), { cartId: cart.cartId });
            formikBag.setSubmitting(true);
            dispatch(clearInlineErrors());
            dispatch(setFormIsSubmitting(true));
            postOrder(payloadToPost)
                .then(function (_a) {
                var _b;
                var data = _a.data;
                formikBag.setSubmitting(false);
                if (data.requiresAction && handleAction) {
                    if (stripe && data.actionInfo.clientSecret) {
                        stripe.handleCardAction(data.actionInfo.clientSecret).then(function (result) {
                            var _a, _b;
                            if (result.error) {
                                setCheckoutError((_b = (_a = result.error) === null || _a === void 0 ? void 0 : _a.message) !== null && _b !== void 0 ? _b : "Something went wrong while verifying your payment information. Please try again or use a different payment method.");
                                formikBag.setSubmitting(false);
                                dispatch(setFormIsSubmitting(false));
                            }
                            if (result.paymentIntent) {
                                delete payload.tokenInfo.paymentMethodId;
                                payload.tokenInfo.paymentIntentId = result.paymentIntent.id;
                                payload.tokenInfo.pendingOrderNumber = data.actionInfo.pendingOrderNumber;
                                placeOrder(values, payload, formikBag, setGlobalError, false);
                            }
                        });
                    }
                    else if (((_b = cart === null || cart === void 0 ? void 0 : cart.paymentProfile) === null || _b === void 0 ? void 0 : _b.gatewayId) === Constants.Gateways.GATEWAY_BOLT &&
                        data.actionInfo.redirectUrl &&
                        data.actionInfo.contractKey) {
                        setBoltToken(data.actionInfo.contractKey);
                        setIframeSrc(data.actionInfo.redirectUrl);
                    }
                }
                else if (!data) {
                    // cart validation failed b/c cart was cleared and null was returned
                    setIsCartExpired(true);
                    formikBag.setSubmitting(false);
                    formikBag.resetForm({ values: values });
                }
                else {
                    formikBag.resetForm({ values: values });
                    dispatch(setFormIsSubmitting(false));
                    dispatch(integrationsEventOrderPlaced(data));
                    dispatch(clearSubmittedForms(eventData.eventNumber.toString()));
                    if (cart) {
                        analytics.purchase(data.result.orderKey, eventData, cart);
                    }
                    handleSubmittedOrder(data.result, eventData, history);
                    dispatch(setCartData(undefined));
                    removeSpecificBFPayment();
                }
            })
                .catch(function (err) {
                var _a, _b, _c, _d, _e;
                dispatch(setInlineError({
                    checkoutForm: (_d = (_c = (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data.errors) === null || _b === void 0 ? void 0 : _b.map(function (err) { return err.value; })) === null || _c === void 0 ? void 0 : _c.join("")) !== null && _d !== void 0 ? _d : (_e = err.response) === null || _e === void 0 ? void 0 : _e.data.message,
                }));
                handleErrors(err, dispatch, formikContext, setGlobalError, undefined, true);
                formikBag.setSubmitting(false);
                dispatch(setFormIsSubmitting(false));
            });
        }
    };
    var isUsingSquare = ((_d = cart === null || cart === void 0 ? void 0 : cart.paymentProfile) === null || _d === void 0 ? void 0 : _d.gatewayId) === Constants.Gateways.GATEWAY_SQUARE ||
        ((_e = cart === null || cart === void 0 ? void 0 : cart.paymentProfile) === null || _e === void 0 ? void 0 : _e.gatewayId) === Constants.Gateways.GATEWAY_SQUARE_SANDBOX;
    if (!((_f = cart === null || cart === void 0 ? void 0 : cart.attendees) === null || _f === void 0 ? void 0 : _f.length) || !initialValues) {
        return null;
    }
    if (!initialValues || !eventData) {
        return null;
    }
    return (_jsxs("div", __assign({ className: "m-bottom-well" }, { children: [_jsx(PaymentForm, { initialValues: initialValues, widgetPaymentRequest: {
                    total: cart.total,
                    paymentMethods: cart.paymentMethods,
                    paymentProfile: cart.paymentProfile,
                    currency: isUsingSquare
                        ? (_k = (_j = (_h = (_g = cart.paymentProfile) === null || _g === void 0 ? void 0 : _g.config) === null || _h === void 0 ? void 0 : _h.currency) === null || _j === void 0 ? void 0 : _j.toUpperCase()) !== null && _k !== void 0 ? _k : "USD"
                        : (_p = (_o = (_m = (_l = cart.paymentProfile) === null || _l === void 0 ? void 0 : _l.options) === null || _m === void 0 ? void 0 : _m.currency) === null || _o === void 0 ? void 0 : _o.toUpperCase()) !== null && _p !== void 0 ? _p : "USD",
                    country: cart.clientCountry,
                    lineItems: cart.attendees.map(function (att) { return ({
                        amount: att.unitTotal,
                        label: att.attendeeDisplay.line1,
                        pending: false,
                    }); }),
                    deliveryMethods: cart.deliveryMethods,
                    clientName: eventData.clientName,
                    referenceOrders: {},
                }, eventData: eventData, path: path, activePath: Constants.Routes.checkout, placeOrder: placeOrder, showPrefilledMessage: showPrefilledMessage, setShowPrefilledMessage: setShowPrefilledMessage, iframeSrc: iframeSrc, setIframeSrc: setIframeSrc, showIframeSrc: showIframeSrc, setShowIframeSrc: setShowIframeSrc, boltToken: boltToken, setBoltToken: setBoltToken, isMobile: isMobile, enableSignup: true }), _jsx(CartExpiredModal, { show: isCartExpired, setShow: setIsCartExpired })] })));
};
export default CartCheckout;
